import { maxLength } from '@carboledger/ui';
import { getTranslation } from '@/lib/utils/i18n';
import { COMPANY_ID_MAX_LENGTH } from './constants/accountSetup.constants';

export const companyProfileValidation = {
  companyId: [
    maxLength(
      COMPANY_ID_MAX_LENGTH,
      getTranslation('VALIDATION_MAX_LENGTH', { max: COMPANY_ID_MAX_LENGTH }),
    ),
  ],
};
